import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { BRAND } from '../mock';
import ReservationDialog from './ReservationDialog';

const NAV = [
  { label: 'Beranda', href: '#home' },
  { label: 'Layanan', href: '#services' },
  { label: 'Tentang', href: '#about' },
  { label: 'Outlet', href: '#outlets' },
  { label: 'Testimoni', href: '#testimonials' },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`sticky top-0 z-50 w-full transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur shadow-sm' : 'bg-white/80 backdrop-blur'}`}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-20 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-3">
          <img src={BRAND.logo} alt="Trust Me Laundry" className="h-12 w-12 rounded-full object-cover ring-2 ring-[color:var(--brand)]/30" />
          <div className="leading-tight">
            <div className="font-display font-extrabold text-[15px] tracking-tight text-[color:var(--ink)]">TRUST ME</div>
            <div className="font-display text-[11px] tracking-[0.2em] text-[color:var(--brand)] font-semibold">LAUNDRY</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <a key={n.href} href={n.href} className="text-[14px] font-medium text-[color:var(--ink)] hover:text-[color:var(--brand)] transition-colors relative after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-[color:var(--brand)] hover:after:w-full after:transition-all">{n.label}</a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a href={`tel:${BRAND.phoneLink}`} className="flex items-center gap-2 text-sm font-semibold text-[color:var(--ink)] hover:text-[color:var(--brand)]">
            <Phone className="w-4 h-4" /> {BRAND.phone}
          </a>
          <ReservationDialog trigger={<button className="btn-brand">Reservasi</button>} />
        </div>

        <button className="lg:hidden p-2" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[color:var(--brand-50)] bg-white">
          <div className="px-5 py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <a key={n.href} href={n.href} onClick={() => setOpen(false)} className="py-2 text-[15px] font-medium text-[color:var(--ink)]">{n.label}</a>
            ))}
            <a href={`tel:${BRAND.phoneLink}`} className="py-2 text-sm font-semibold flex items-center gap-2"><Phone className="w-4 h-4" /> {BRAND.phone}</a>
            <ReservationDialog trigger={<button className="btn-brand w-full">Reservasi</button>} />
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
